import { FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import { getAssetCommands, AssetCommand, isCommandButton } from 'owa-timestream-asset-sdk';
import type { AssetId } from 'owa-timestream-types';
import loc from 'owa-localize';
import { getSelectedProjectId } from 'owa-timestream-store';
import { deleteSelectedAssets } from 'owa-timestream-canvas';

export default function getAssetCommandMenuItems(assets: AssetId[]) {
    const assetCommands = getAssetCommands(getSelectedProjectId(), assets, deleteSelectedAssets);

    return assetCommands.map(command => {
        return new FilterableMenuItem({
            [FilterableMenuItemArgs.id]: command.id,
            [FilterableMenuItemArgs.key]: command.id,
            [FilterableMenuItemArgs.name]: loc(command.titleResourceId),
            [FilterableMenuItemArgs.icon]: command.iconName,
            ...getMenuItemBehavior(command),
        });
    });
}

function getMenuItemBehavior(command: AssetCommand) {
    if (isCommandButton(command)) {
        return {
            [FilterableMenuItemArgs.onClick]: ev => {
                command.onInvoke();
            },
        };
    } else {
        return {
            [FilterableMenuItemArgs.menuContent]: {
                ...(command.getMenuProps ? command.getMenuProps() : {}),
                items: command.getMenuItems(),
            },
        };
    }
}
